module.exports = __webpack_public_path__ + "static/media/994599.c0012fa7.png";